import { useEffect } from "react";

/**
 * 사용자가 다시 페이지로 돌아왔을 때 (탭 활성화될 때) 콜백 실행
 * @param onVisible - 페이지가 다시 보일 때 실행할 함수
 */
function useOnPageVisible(onVisible: () => void) {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        onVisible();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [onVisible]);
}

export default useOnPageVisible;
